var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMochila(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.857,
    height: 64,
    viewBox: "0 0 54.857 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_684",
    "data-name": "Grupo 684",
    transform: "translate(-1333.977 -2675)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_220",
    "data-name": "Trazado 220",
    d: "M274.287,430.574H288.01a2.287,2.287,0,0,0,0-4.574H274.287a2.287,2.287,0,1,0,0,4.574Z",
    transform: "translate(1080.256 2267.285)",
    fill: "#00c1d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_221",
    "data-name": "Trazado 221",
    d: "M312,430.023v-7.451A4.585,4.585,0,0,0,307.429,418h-4.571a4.585,4.585,0,0,0-4.571,4.571v4.571H284.571v-4.571A4.585,4.585,0,0,0,280,418h-4.571a4.585,4.585,0,0,0-4.571,4.571v7.451A15.992,15.992,0,0,0,264,443.143v34.286A4.585,4.585,0,0,0,268.571,482h45.714a4.585,4.585,0,0,0,4.571-4.571V443.143A16.024,16.024,0,0,0,312,430.023Zm-9.143-7.451h4.571v5.234a15.79,15.79,0,0,0-4.571-.663Zm-27.429,0H280v4.571a16.611,16.611,0,0,0-4.571.663Zm-6.857,54.857V443.143A11.433,11.433,0,0,1,280,431.714h22.857a11.433,11.433,0,0,1,11.429,11.429v34.286Z",
    transform: "translate(1069.977 2257)",
    fill: "#00c1d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_222",
    "data-name": "Trazado 222",
    d: "M295.42,430H277.14a9.142,9.142,0,0,0-9.14,9.149v13.723a4.586,4.586,0,0,0,4.57,4.574h27.42a4.586,4.586,0,0,0,4.57-4.574V439.149A9.142,9.142,0,0,0,295.42,430Zm4.57,22.872H272.57V439.149a4.586,4.586,0,0,1,4.57-4.574h18.28a4.586,4.586,0,0,1,4.57,4.574Z",
    transform: "translate(1075.125 2272.405)",
    fill: "#00c1d4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMochila);
export default __webpack_public_path__ + "static/media/mochila.f3d79132a2b4d98a0436780abca1db70.svg";
export { ForwardRef as ReactComponent };